import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const MissionVisionPage = lazy(() => import('../pages/mission-vision/page'));
const DirectorsPage = lazy(() => import('../pages/directors/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const CareerPage = lazy(() => import('../pages/career/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NewsResearchPage = lazy(() => import('../pages/news-research/page'));
const NewsResearchDetailPage = lazy(() => import('../pages/news-research/detail/page'));
const AddContentPage = lazy(() => import('../pages/news-research/add-content/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const MyLeadsPage = lazy(() => import('../pages/my-leads/page'));
const AdminDetailsPage = lazy(() => import('../pages/admin-details/page'));
const CefiximeTrihydratePage = lazy(() => import('../pages/products/cefixime-trihydrate/page'));
const OurProductsPage = lazy(() => import('../pages/products/our-products/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/mission-vision',
    element: <MissionVisionPage />,
  },
  {
    path: '/directors',
    element: <DirectorsPage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/career',
    element: <CareerPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/news-research',
    element: <NewsResearchPage />,
  },
  {
    path: '/news-research-details/:id',
    element: <NewsResearchDetailPage />,
  },
  {
    path: '/news-research/add-content',
    element: <AddContentPage />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />,
  },
  {
    path: '/my-leads',
    element: <MyLeadsPage />,
  },
  {
    path: '/admin-details',
    element: <AdminDetailsPage />,
  },
  {
    path: '/products/cefixime-trihydrate',
    element: <CefiximeTrihydratePage />,
  },
  {
    path: '/products/our-products',
    element: <OurProductsPage />,
  },
];

export default routes;
